"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Simple truthy-only, unique intersection function of two arrays.
 *
 * @param Array   array1
 * @param Array   array2
 *
 * @return Array
 */
function simpleIntersection(array1, array2) {
  return array1
  // Remove falsy elements
  .filter(function (el) {
    return el;
  })
  // Match elements belonging in the two arrays
  .filter(function (el) {
    return array2.indexOf(el) !== -1;
  })
  // Remove duplicates
  .filter(function (el, idx, arr) {
    return arr.indexOf(el) === idx;
  });
}

/**
 * Returns the best match for the user's locale.
 *
 * @param Array   preferedLocales   the locales requested
 * @param Array   availableLocales  locales available for the application
 * @param String  defaultLocale     the fallback locale
 *
 * @return String
 */
var negociateLocale = function negociateLocale() {
  var preferedLocales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var availableLocales = arguments[1];
  var defaultLocale = arguments[2];

  var validLanguages = simpleIntersection(preferedLocales, availableLocales);

  if (validLanguages.length) {
    return validLanguages[0];
  }

  return defaultLocale;
};
exports.default = negociateLocale;


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/tools/negociateLocale.js
// module id = 516
// module chunks = 0